import { CombinedVueInstance } from "vue/types/vue";

export class Tooltip {
	private static instance: Tooltip;
	private currentlyOpenedTooltip: CombinedVueInstance<any, any, any, any, any> | null = null;

	private constructor() {
	}

	static getInstance(): Tooltip {
		if (Tooltip.instance == null) {
			Tooltip.instance = new Tooltip();
		}
		return Tooltip.instance;
	}

	setCurrentlyOpenedTooltip(tooltip: CombinedVueInstance<any, any, any, any, any>) {
		if (this.currentlyOpenedTooltip && this.currentlyOpenedTooltip !== tooltip) {
			this.currentlyOpenedTooltip.closeTooltip();
		}
		this.currentlyOpenedTooltip = tooltip;
	}

	closeCurrentlyOpenedTooltip() {
		if (this.currentlyOpenedTooltip) {
			this.currentlyOpenedTooltip.closeTooltip();
		}
	}
}